const TAGS = {
    isInCanaryExperimentalGroup: 'is_in_canary_experimental_group',
    isMfInCanary: 'is_mf_in_canary',
    version: 'version',
};

export { TAGS };
